import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import ButtonBase from '@mui/material/ButtonBase';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import { userIdSelector } from '../../app/main/mainSlice';
import { useAppSelector } from '../../app/store/hooks';
import useFetchUplainceReview from '../../hooks/useFetchUplainceReview';
import useFetchReferralData from '../../hooks/useGetReferralDetails';
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { AlertIcon, EditReview, RefferalBanner, ShareIcon } from '../../iconRef/referralIcons';
import { ErrorManagementContext } from '../../utils/errorManagement/ErrorManagementProvider';
import { GoBackIcon } from '../../utils/iconRefs/recipeRatingIcons';
import styles from './ViewRateUpliance.module.css';

const Loader = ({ loading }: { loading: boolean }) => (
    <Modal open={loading}>
        <Grid className={styles.loader_container}>
            <CircularProgress className={styles.loader} />
        </Grid>
    </Modal>
)

const ViewRateUpliance = () => {
    const history = useHistory();
    const userId = useAppSelector(userIdSelector);
    const handleOnCompleted = (reviewText: string | null) => {
        if (!reviewText)
        history.replace('/account/rate-upliance');

    };

    const handleOnError = () => {
        history.push('/account');
    };
    const { review_text, review_image, loading } = useFetchUplainceReview(handleOnCompleted,handleOnError);
    const { referralLink, title, subtitle, amount, loading: referralLoading, logShareReferralLink } = useFetchReferralData();
    const { cookClubLog } = useContext(ErrorManagementContext);
    const { logRecipeEdit } = useLogRecipeEdit();

    const onEditClick = () => {
        logRecipeEdit('REVIEW_EDIT_CLICKED', {})
        history.push('/account/rate-upliance')
    }

    const onGoBack = () => {
        history.push('/account')
    }

    const onShareClick = async () => {
        const shareMessage = `${title}
        \n${review_text}
        \n${subtitle} ${amount}
        \n${referralLink}`;

        try {
            if (navigator.share) {
                const shareData: { text: string } = {
                    text: shareMessage,
                };

                // if (review_image) {
                //     const response = await fetch(review_image);
                //     const blob = await response.blob();
                //     const file = new File([blob], 'review-image.jpg', { type: blob.type });
                //     shareData.files = [file];
                // }

                await navigator.share(shareData);
                logShareReferralLink();
            } else {
                cookClubLog(
                    "",
                    "Sharing is not supported in this browser. Please copy the link manually.",
                    '',
                    { ui: { type: "error" }, browserConsole: true })
            }
        } catch (error) {
            console.error('Error sharing:', error);
        }
    };

    return (
        <Grid className={styles.container} container>
            <Grid className={styles.referral_banner_container} item>
                <Grid className={styles.close_icon} item>
                    <GoBackIcon onClick={onGoBack} />
                </Grid>

                <RefferalBanner />
                <Grid className={styles.banner_text_container}>
                    <Typography align="center" component="p" variant="popupTitleOutfit">
                        Save a friend
                    </Typography>
                    {!review_text ? <Typography align="center" component="p" variant="caption3LightOutfit">
                        Enable referral code by sharing your review.
                    </Typography> : null}
                </Grid>
                <Grid className={styles.banner_refferal_container}>
                    <Grid className={styles.refferal_link_container}>
                        <Typography className={styles.referral_text} variant='ingredientText2paralellOutfit'>{referralLoading ? "loading..." : referralLink}</Typography>
                        <ButtonBase className={styles.share_btn} disabled={referralLoading} onClick={onShareClick}>
                            <Typography className={styles.share_btn_text}  variant='caption4LightOutfit'>
                                Share
                            </Typography>
                            <ShareIcon />
                        </ButtonBase>
                    </Grid>
                    <Grid className={styles.referral_alert_container}>
                        <AlertIcon />
                        <Typography className={styles.refferal_info_text} variant='caption4LightOutfit'>This link is valid for 24 hours only</Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid className={styles.referral_form_container} item>
                <Grid className={styles.referral_edit_btn_container} item>
                    <Typography className={styles.heading} variant="cardOutfit">
                        Tell us how Upliance has helped in your kitchen
                    </Typography>
                    <ButtonBase className={styles.edit_btn} onClick={onEditClick}>
                        <EditReview />
                        <Typography variant='caption4LightOutfit'>
                            Edit
                        </Typography>
                    </ButtonBase>
                </Grid>

                {review_text ? <Grid className={styles.review_container} item>
                    <Typography variant='caption4LightOutfit'>
                        {review_text}
                    </Typography>
                </Grid> : null}

                {/* {review_image ?
                    <Grid item className={styles.referral_img_container}>
                        <img
                            src={review_image}
                            className={styles.referral_img}
                        />
                    </Grid>
                    : null
                } */}

            </Grid>
            <Loader loading={loading} />

        </Grid>
    );
};

export default ViewRateUpliance;
